import { ClassGetter } from '@angular/compiler/src/output/output_ast';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-header-integracion-hc',
  templateUrl: './header-integracion-hc.component.html',
  styleUrls: ['./header-integracion-hc.component.css']
})
export class HeaderIntegracionHcComponent implements OnInit {

  @Input() fechas: SelectItem[];
  @Input() readyImpresion: boolean;
  @Output() indices = new EventEmitter<Number[]>();
  @Output() generarReporte = new EventEmitter<any>();
  fechasSelected: Number[] = [];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    if(this.fechas.length > 0) {
      this.fechasSelected = [];
      this.fechas.map(({value}) => this.fechasSelected.push(value));
    }
  }

  cambioFechas() {
    this.indices.emit(this.fechasSelected);
  }

  onGenerar() {
    this.generarReporte.emit();
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('integracion-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }
}
